import { React, useState }  from "react";
import axios from "axios";

import "./ReviewModal.css";
import { API_BASE_URL } from "../../Variables";
import StarRating from "../StarRating";
import ConfirmationModal from "../../components/ConfirmationModal";

function ReviewModal( {onClose, review, bookId, updatingReview = false} ) {
  const paceOptions = ['Fast', 'Medium', 'Slow'];
  const plotCharacterDrivenOptions = ['Plot Driven', 'Character Driven', 'Balanced'];
  const token = localStorage.getItem('token');

  const [rating, setRating] = useState(review?.rating || 0);
  const [reviewText, setReviewText] = useState(review?.review_text || "");
  const [paceReview, setPaceReview] = useState(review?.pace_review || "");
  const [plotCharacterDriven, setPlotCharacterDriven] = useState(review?.plot_character_driven || "");
  const [developmentReview, setDevelopmentReview] = useState(review?.development_review || "");
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [error, setError] = useState(null);

  // Handles the save button click
  const handleSave = async () => {
    setError(null);

    if (rating === 0) {
      setError('Rating is required');
      return;
    }

    if(updatingReview) {
      updateReview();
    }
    else {
      createReview();
    }
  };

  // Create review
  const createReview = async () => {
    try{
      await axios.post(`${API_BASE_URL}/reviews`, {
        book_id: bookId,
        rating,
        review_text: reviewText,
        pace_review: paceReview,
        plot_character_driven: plotCharacterDriven,
        development_review: developmentReview
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      onClose();
    }
    catch (error) {
      if(error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      }
      else {
        setError('An error occurred while creating the review');
      }
    }
  };

  // Update review
  const updateReview = async () => {
    try{
      axios.put(`${API_BASE_URL}/reviews/${bookId}`, {
        book_id: bookId,
        rating,
        review_text: reviewText,
        pace_review: paceReview,
        plot_character_driven: plotCharacterDriven,
        development_review: developmentReview
      }, {
        headers: { Authorization: `Bearer ${token}`},
        params: { book_id: bookId }
      });
      
      onClose();
    }
    catch (error) {
      if(error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      }
      else {
        setError('An error occurred while updating the review');
      }
    }
  };

  // Delete review
  const onDelete = async () => {
    try{
      await axios.delete(`${API_BASE_URL}/reviews/${bookId}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { book_id: bookId }
      });

      onClose();
    }
    catch (error) {
      if(error.response && error.response.data && error.response.data.error) {
        setError(error.response.data.error);
      }
      else {
        setError('An error occurred while deleting the review');
      }
    }
  };

  // Handles the delete button click by opening the confirmation modal
  const handleDeleteConfirmation = () => {
    setOpenConfirmDelete(true);
  };

  return (
    <div className="modal-overlay">
      <div className="review-modal">
        <h2>Review</h2>
        
        <div className="modal-section">
          <label>Rating:</label>
          <StarRating rating={rating || 0} isReviewing={true} onRatingChange={setRating} />
        </div>
        
        <div className="modal-section">
          <label>Review:</label>
          <textarea
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
            placeholder="Write your review here. Optional."
          />
        </div>

        <div className="modal-section">
          <label>Pace:</label>
          <div className="review-selection">
            {paceOptions.map((option) => (
              <div key={option} className="selectable-item" onClick={() => setPaceReview(option)}>
                <div className={paceReview === option ? "selected-circle" : "circle"}/>
                <span>{option}</span>
              </div>
            ))}
          </div>
        </div>  

        <div className="modal-section">
          <label>Plot/Character Driven:</label>
          <div className="review-selection">
            {plotCharacterDrivenOptions.map((option) => (
              <div key={option} className="selectable-item" onClick={() => setPlotCharacterDriven(option)}>
                <div className={plotCharacterDriven === option ? "selected-circle" : "circle"}/>
                <span>{option}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="modal-section">
          <label>Development Review:</label>
          <textarea
            value={developmentReview}
            onChange={(e) => setDevelopmentReview(e.target.value)}
            placeholder="Development review. Optional."
          />
        </div>
        
        {error && <p className="error">{error}</p>}

        {updatingReview && <button onClick={() => handleDeleteConfirmation()} className="important-button">Delete</button>}
        <button onClick={handleSave} className="tertiary-button">Save</button>
        <button onClick={() => onClose()} className="secondary-button">Cancel</button>
        
        {openConfirmDelete && (
          <ConfirmationModal
            onClose={() => setOpenConfirmDelete(false)}
            onConfirm={() => onDelete()}
            title="Delete Review"
            message={
              "Are you sure you want to delete this review? This action cannot be undone."
            }
          />
        )}

      </div>
    </div>
  );
}

export default ReviewModal;
